var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnderwater(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#222222"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0676 11C16.4483 11 17.5676 9.88071 17.5676 8.5C17.5676 7.11929 16.4483 6 15.0676 6C13.6869 6 12.5676 7.11929 12.5676 8.5C12.5676 9.88071 13.6869 11 15.0676 11Z",
    fill: "#2d2d2d",
    stroke: "#2d2d2d",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 13.9189C7.32843 13.9189 8 13.2473 8 12.4189C8 11.5905 7.32843 10.9189 6.5 10.9189C5.67157 10.9189 5 11.5905 5 12.4189C5 13.2473 5.67157 13.9189 6.5 13.9189Z",
    fill: "#2d2d2d",
    stroke: "#2d2d2d",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1892 18.2162C13.7415 18.2162 14.1892 17.7685 14.1892 17.2162C14.1892 16.6639 13.7415 16.2162 13.1892 16.2162C12.6369 16.2162 12.1892 16.6639 12.1892 17.2162C12.1892 17.7685 12.6369 18.2162 13.1892 18.2162Z",
    fill: "#2d2d2d",
    stroke: "#2d2d2d",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderwater);
export default __webpack_public_path__ + "static/media/underwater.66946b84838c0f7cf05d91c21ec26534.svg";
export { ForwardRef as ReactComponent };